export const redirectUrlFromSearch = () => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has("redirect_url")) {
    return searchParams.get("redirect_url");
  } else {
    return null;
  }
};
export const parsedRedirectUrlFromSearch = () => {
  let redirectUrl = redirectUrlFromSearch();

  if (redirectUrl) {
    try {
      return new URL(redirectUrl).toString();
    } catch (e) {
      try {
        // Convert URL-safe base64 to standard base64
        // URL-safe base64 uses - and _ instead of + and /
        const base64 = redirectUrl.replace(/-/g, "+").replace(/_/g, "/");

        const decoded = atob(base64);
        return new URL(decoded).toString();
      } catch {
        // Failed to decode or parse URL
      }
    }
  }
  return null;
};
